// outsource dependencies
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import config from 'constants/config';

import de from './de.json';
import en from './en.json';

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: config.LANGUAGE,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en,
      de
    }
  });

export default i18n;
